const data = {
  'Selected': 'Seçilen: {0} - {1}',
  'Uploading files': 'Yükleniyor {0}% - {1}',
  'File size error': '{0} çok büyük, lütfen {1} den küçük dosya yükleyin',
  'Upload failed': '{0} yüklenemedi',
  'Per page': 'Sayfa başına {0} tane',
  'Folder': 'Klasör',
  'Login failed, please try again': 'Giriş başarısız. Lütfen tekrar deneyin',
  'Already logged in': 'Zaten giriş yapılmış.',
  'Please enter username and password': 'Lütfen kullanıcı adınızı ve şifrenizi giriniz.',
  'Not Found': 'Bulunamadı',
  'Not Allowed': 'İzin verilmedi',
  'Please log in': 'Lütfen giriş yapın',
  'Unknown error': 'Bilinmeyen hata',
  'Add files': 'Dosya Ekle',
  'New': 'Yeni',
  'New name': 'Yeni Ad',
  'Username': 'Kullanıcı Adı',
  'Password': 'Parola',
  'Login': 'Giriş',
  'Logout': 'Çıkış',
  'Profile': 'Profil',
  'No pagination': 'Sayfa Yok',
  'Time': 'Zaman',
  'Name': 'Ad',
  'Size': 'Boyut',
  'Home': 'Anasayfa',
  'Copy': 'Kopyala',
  'Move': 'Taşı',
  'Rename': 'Yeniden adlandır',
  'Required': 'Lütfen bu alanı doldurun',
  'Zip': 'Zip',
  'Batch Download': 'Batch İndirme',
  'Unzip': 'Zipi çıkart',
  'Delete': 'Sil',
  'Download': 'İndir',
  'Copy link': 'Bağlantıyı Kopyala',
  'Done': 'Tamam',
  'File': 'Dosya',
  'Drop files to upload': 'Yüklemek için dosyayı sürükle',
  'Close': 'Kapat',
  'Select Folder': 'Klasör Seç',
  'Users': 'Kullanıcılar',
  'Files': 'Dosyalar',
  'Role': 'Rol',
  'Cancel': 'İptal',
  'Paused': 'Durduruldu',
  'Confirm': 'Onayla',
  'Create': 'Oluştur',
  'User': 'Kullanıcı',
  'Admin': 'Admin',
  'Save': 'Kaydet',
  'Read': 'Okuma',
  'Write': 'Yazma',
  'Upload': 'Yükleme',
  'Permissions': 'İzimler',
  'Homedir': 'Ana Klasör',
  'Leave blank for no change': 'Değişiklik yapmamak için boş bırakın',
  'Are you sure you want to do this?': 'Bunu yapmak istediğinizden emin misiniz?',
  'Are you sure you want to allow access to everyone?': 'Herkese erişime izin vermek istediğinizinden emin misiniz?',
  'Are you sure you want to stop all uploads?': 'Tüm yüklemeleri durdurmak istediğinizden emin misiniz?',
  'Something went wrong': 'Bir şeyler yanlış gitti',
  'Invalid directory': 'Geçersiz dizin',
  'This field is required': 'Bu alan gereklidir',
  'Username already taken': 'Kullanıcı adı önceden alınmış',
  'User not found': 'Kullanıcı bulunamadı',
  'Old password': 'Eski parola',
  'New password': 'Yeni parola',
  'Wrong password': 'parola hatalı',
  'Updated': 'Güncellendi',
  'Deleted': 'Silindi',
  'Your file is ready': 'Dosyanız Hazır',
  'View': 'View',
}

export default data

